<template>
  <div>
    <h3 class="checkout-h3 confirmation-subtitle">{{ deliveryObject ? deliveryObject.nome : delivery.name }}</h3>
    <p class="grey--text">{{ deliveryObject ? deliveryObject.descricao : delivery.summary }}</p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters(['deliveryObject'])
  },
  data() {
    return {
      delivery: {
        name: 'Bilheteria do evento',
        summary:
          'No dia do evento, apresente na bilheteria o código do pedido, seu documento com foto e o cartão usado na compra para retirar seus ingressos.',
      },
    };
  },
};
</script>
